import React, { Component } from "react";
import ReactGA from "react-ga";
import "./ContactForm.css";
import ContactService from "./../../../../services/ContactService";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      phone: "",
      company: "",
      from_email: "",
      name: "",
      phone_error: "",
      from_email_error: "",
      name_error: "",
      message_error: "",
      company_error: "",
      status: "fa",
      request_message: "",
      success_style: {}
    };
    this.checkRequest = this.checkRequest.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      [event.target.name + "_error"]: ""
    });
  }
  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      ReactGA.event({
        category: "contact-form",
        action: "Send",
        label: "success"
      });
      this.setState({
        message: "",
        phone: "",
        company: "",
        from_email: "",
        name: "",
        status: "fa",
        request_message:
          "Tack för ditt meddelande! Vi hör snart av oss till dig.",
        success_style: { color: "white" }
      });
    } else {
      ReactGA.event({
        category: "contact-form",
        action: "Send",
        label: "fail"
      });
      this.setState({
        request_message: "Ett fel uppstod, vänligen försök igen.",
        success_style: {},
        status: "fa"
      });
      if (response.status === 400) {
        return response.json();
      }
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }
  checkRequest(response) {
    Object.keys(response).forEach(
      function(key) {
        if (response[key] !== undefined) {
          this.setState({
            [key + "_error"]: response[key][0]
          });
        }
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: "fa fa-spinner fa-pulse fa-fwk"
    });
    ContactService.sendContactForm(
      this.state.name,
      this.state.company,
      this.state.from_email,
      this.state.phone,
      this.state.message
    )
      .then(this.checkStatus)
      .then(this.checkRequest)
      .catch(function() {});
  }
  render() {
    return (
      <div className="row contact-form">
        <form
          className="col-xl-10 offset-xl-1 col-12 text-center"
          id="contact-form"
          onSubmit={this.handleSubmit}
        >
          <div className="row form-row">
            <div className="form-group col-lg-6">
              <div className="row">
                <div className="contact-icon col-1">
                  <i className="fa fa-user" />
                </div>
                <div className="col-11 input-col ">
                  <label htmlFor="name" className="control-label sr-only">
                    Namn
                  </label>
                  <input
                    type="text"
                    className="form-control input-lg"
                    name="name"
                    onChange={this.handleChange}
                    placeholder="Namn"
                    value={this.state.name}
                  />
                  <div
                    style={this.state.name_error ? {} : { height: "40px" }}
                  />
                </div>
                <div className="error-message">
                  <label htmlFor="error" className="error">
                    {this.state.name_error}
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group col-lg-6 ">
              <div className="row">
                <div className="contact-icon col-1">
                  <i className="fa fa-envelope" />
                </div>
                <div className="col-11 input-col">
                  <label htmlFor="form_email" className="control-label sr-only">
                    E-post
                  </label>
                  <input
                    type="text"
                    className="form-control input-lg"
                    name="from_email"
                    onChange={this.handleChange}
                    placeholder="E-post"
                    value={this.state.from_email}
                  />
                  <div
                    style={
                      this.state.from_email_error ? {} : { height: "40px" }
                    }
                  />
                </div>
                <div className="error-message">
                  <label htmlFor="error" className="error">
                    {this.state.from_email_error}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row form-row">
            <div className="form-group col-lg-6 optional">
              <div className="row">
                <div className="contact-icon col-1">
                  <i className="fa fa-home" />
                </div>
                <div className="col-11 input-col">
                  <input
                    type="text"
                    className="form-control input-lg"
                    name="company"
                    onChange={this.handleChange}
                    placeholder="Företag (valbar)"
                    value={this.state.company}
                  />
                </div>
              </div>
            </div>
            <div className="form-group col-lg-6 optional">
              <div className="row">
                <div className="contact-icon col-1">
                  <i className="fa fa-phone" />
                </div>
                <div className="col-11 input-col">
                  <input
                    type="text"
                    className="form-control input-lg"
                    name="phone"
                    onChange={this.handleChange}
                    placeholder="Telefon (valbar)"
                    value={this.state.phone}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-12 text-area-col">
              <textarea
                className="form-control input-lg message"
                rows="5"
                onChange={this.handleChange}
                name="message"
                placeholder="Meddelande"
                value={this.state.message}
              />
              <div className="error-message">
                <label htmlFor="error" className="error">
                  {this.state.message_error}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mx-auto text-center ">
              <button
                type="submit"
                className="sendButton btn-white col-12"
                disabled={this.state.status === "fa fa-spinner fa-pulse fa-fwk"}
                name="sendButton"
              >
                <span>Skicka</span>
                <i id="sendIcon" className={this.state.status} />
              </button>
              <div className="error-message">
                <label
                  htmlFor="error"
                  className="error"
                  style={this.state.success_style}
                >
                  {this.state.request_message}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/routes/Contact/components/ContactForm/ContactForm.jsx